import type { EventFilters } from '@/features/publicsite/types/events/EventFilters';
import type { PublicEventsKey } from '@/i18n/dictionaries/publicEvents';

// What the calendar tells the reader about what it is showing — how many events, or why there are
// none. Dictionary keys rather than sentences, so the page decides the language at render time and
// these stay testable without one.

/**
 * How many events the filters left, as a key.
 *
 * Zero is named rather than counted. Romanian's plural rules put 0 in the same form as 2–19 ("0
 * evenimente"), which is correct grammar and a poor sentence: the reader is being told the answer
 * is empty, and „Niciun eveniment" says that where a leading zero has to be read first.
 */
export function calendarCountMessage(totalItems: number): PublicEventsKey {
  return totalItems === 0 ? 'noEvents' : 'resultsCount';
}

/**
 * What an empty calendar says, as a key.
 *
 * A period is named on its own because it is the one filter the reader can be wrong about without
 * knowing it: a shared link carries a period that has since emptied, and "no event matches the
 * selected filters" over a calendar whose other filters are all off reads as a broken page.
 */
export function emptyCalendarMessage(filters: EventFilters): PublicEventsKey {
  if (filters.from || filters.to) return 'periodEmptyState';
  return Object.keys(filters).length > 0 ? 'filteredEmptyState' : 'emptyState';
}
